import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtropehistorial'
})
export class FiltropehistorialPipe implements PipeTransform {

  transform(value: any, args: any): any {
    const resultPost = [];
    for ( const post of value) {
      if (post.enviadoporemail) {
        resultPost.push (post);
        
      }
      
    }

    return resultPost;
  }

}
